import { All, KeyValue } from "../interfaces";
import { connect } from "react-redux";
import * as actions from "../common/actions";
import { Dispatch } from "react";
import MarketShare from "../components/SOD/MarketShare/MarketShare";

function mapStateToProps({ appState }: All) {
  return {
    appState: (appState as KeyValue)[appState.app],
  };
}
export function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    updateFilter: (filterField: string, value: string | string[]) => {
      dispatch(actions.updateFilter(filterField, value));
    },
    updateUi: (uiField: string, value: string | KeyValue[]) => {
      dispatch(actions.updateUi(uiField, value));
    },
    updatePagination: () => {
      dispatch(actions.updatePagination("pageNumber", 1));
    },
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(MarketShare);
